module.exports = __webpack_public_path__ + "img/2-2.79c76a17.png";